"use strict";

exports.__esModule = true;
var _UpdateDeviceScreenPlantTwin = require("./UpdateDeviceScreenPlantTwin");
Object.keys(_UpdateDeviceScreenPlantTwin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateDeviceScreenPlantTwin[key]) return;
  exports[key] = _UpdateDeviceScreenPlantTwin[key];
});